<template>
  <CSidebar
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <div class="m-auto logo-temp text-uppercase text-center ">
        <div
          class="imgLogo"
          v-bind:style="{
            'background-image': 'url(' + img + ')',
          }"
        ></div>
      </div>
    </CSidebarBrand>
    <div class="text-center mt-2 pt-2 d-none" :class="[{ 'd-none': minimize }]">
      <img :src="img" alt="logo" class="w-25" />
      <h4 class="font-weight-bold mt-2 username">{{ name }}</h4>

      <b-row class="no-gutters py-3 user-btn mt-4">
        <b-col>
          <div>
            <font-awesome-icon icon="user" />
          </div>
          <p class="m-0">Profile</p>
        </b-col>
        <b-col class="pointer" @click.prevent="handleLogout">
          <div>
            <font-awesome-icon icon="power-off" />
          </div>
          <p class="m-0">Logout</p>
        </b-col>
      </b-row>
    </div>

    <CRenderFunction flat :contentToRender="sidebarItems" />
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />

    <ModalAlertConfirm
      msg="Log out"
      :text="modalMessage"
      colorBtnConfirm="primary"
      btnCancel="Cancel"
      btnConfirm="OK"
      ref="isModalAlertConfirm"
      @confirm="logout"
    />
  </CSidebar>
</template>

<script>
import SidebarItems from "./SidebarItems";
import { mapState } from "vuex";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import VueCookies from "vue-cookies";
import img from "@/assets/images/logo.svg";

export default {
  name: "TheSidebar",
  extends: SidebarItems,
  components: {
    ModalAlertConfirm
  },
  data() {
    return {
      modalMessage: "Are you sure you want to log out ?",
      name: "",
      img: img,
      imgLogo: "",
      navFiltered: null
    };
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    ...mapState({
      minimize: (state) => state.sidebarMinimize,
    }),
  },
  created() {
    setTimeout(async () => {
      this.handleActiveMenuChild(this.$route.meta);
    }, 650);
  },
  watch: {
    "$route.meta"(newValue, oldValue) {
      this.handleActiveMenu(newValue, oldValue);
    },
  },
  mounted: async function() {
    this.name = VueCookies.get("username");
    //this.getLogo();
  },
  methods: {
    handleLogout() {
      this.$refs.isModalAlertConfirm.show();
    },
    logout: async function() {
      this.$refs.isModalAlertConfirm.hide();
      this.$cookies.remove("admin-token");
      this.$cookies.remove("chat-agent-token");
      window.location.href = "/login";
    },
    handleActiveMenu: async function(newValue, oldValue) {
      document.body.style.setProperty("--margin-bottom", "0px");
      if (newValue.activeUrl != oldValue.activeUrl) {
        await this.handleRemoveActiveMenuChild(oldValue, newValue);
      }
      await this.handleActiveMenuChild(newValue);
    },
    handleActiveMenuChild: async function(meta) {
      this.routeMeta = meta;
      var ele = await this.getAllElementsWithAttribute(
        "a",
        "href",
        meta.activeUrl
      );
      if (meta.isChildren && ele.className == "c-sidebar-nav-link")
        await ele.setAttribute("class", "active c-sidebar-nav-link");

      var parentElement = ele;
      if (meta.lv == 1 && ele.className == "c-sidebar-nav-dropdown") {
        ele.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      } else if (meta.lv == 2) {
        parentElement = parentElement.parentElement.parentElement.parentElement;
        if (
          parentElement &&
          parentElement.className == "c-sidebar-nav-dropdown"
        )
          parentElement.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      }

      if (
        meta.lv == 3 &&
        parentElement.parentElement.parentElement.className.includes(
          "c-sidebar-nav-dropdown"
        )
      ) {
        if (
          !parentElement.parentElement.parentElement.className.includes(
            "c-show"
          )
        ) {
          parentElement.parentElement.parentElement.setAttribute(
            "class",
            "c-sidebar-nav-dropdown-items"
          );
        }
        ele.classList.add("active");
      }
    },
    handleRemoveActiveMenuChild: async function(oldMeta, newMeta) {
      var oldEle = this.getAllElementsWithAttribute(
        "a",
        "href",
        oldMeta.activeUrl
      );
      if (!oldEle) return;

      oldEle = await this.getAllElementsWithAttribute(
        "a",
        "href",
        oldMeta.activeUrl
      );
      oldEle.classList.remove("active");
      if (oldMeta.parent != newMeta.parent) {
        let dropdown = oldEle.closest(".c-sidebar-nav-dropdown");
        if (dropdown) {
          dropdown.classList.remove("c-show");
        }
      }
    },
    getAllElementsWithAttribute(tagName, attribute, val) {
      var allElements = Array.from(document.getElementsByTagName(tagName));
      var filtered = allElements.filter((ele) => {
        return (
          ele.getAttribute(attribute) !== null &&
          ele.getAttribute(attribute) == val
        );
      });
      if (filtered.length) return filtered[0];
      else return false;
    },
  },
};
</script>

<style scoped>
#logo-main {
  background-image: url("/img/brand/coreui-base-white.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.logo-temp {
  color: #242424;
  font-size: 24px;
  font-weight: bold;
  width: 60% !important;
}

.user-btn {
  background: #373122;
}

.username {
  font-size: 18px;
}

.w-50px {
  width: 100px;
}
</style>
